module.exports = __webpack_public_path__ + "media/packs/images/partners/okko_bg-00013515c537a3a8488d07bd23e37d43.jpg";